import React from "react";
import i18next from "i18next";
import emblem from "./emblem.png";
import emblemCircle from "./emblem-circle.png";
import "./LoadingScreen.less";

// Full-page loading screen, same as the membership admin's: the storefront emblem with the
// "BRING YOUR A GAME" ring turning around it, on the Aviron ink background.
function LoadingScreen() {
  return (
    <div className="aviron-loading-screen" role="status" aria-live="polite" aria-busy="true" aria-label={i18next.t("login:Loading")}>
      <div className="aviron-loading-emblem" aria-hidden="true">
        <img src={emblem} alt="" />
        <img src={emblemCircle} alt="" className="aviron-loading-ring" />
      </div>
    </div>
  );
}

export default LoadingScreen;
